import styled, { css } from 'styled-components'

import { truncateStyles, Flex, FlexProps } from '@sketch/components'
import { Image as ImageUnstyled } from '@sketch/modules-common'
import { ExternalLinkIcon } from '../../../FrameDetailInspectorSymbolLink'

const SymbolDetail = styled(Flex)<FlexProps & SymbolBoxProps>(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.D};
    color: ${theme.colors.foreground.secondary.C};
    ${truncateStyles};
  `
)

interface SymbolBoxProps extends FlexProps {
  isClickable?: boolean
}

export const SymbolBox = styled(SymbolDetail)<SymbolBoxProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 8px;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  cursor: ${props => (props.isClickable ? 'pointer' : 'auto')};
`

export const SymbolHoverContainer = styled.div(
  ({ theme }) => css`
    cursor: pointer;
    height: 48px;
    position: relative;
    display: flex;
    align-items: center;
    border-radius: ${theme.radii.large};

    padding-top: 4px;
    padding-bottom: 4px;
    margin-bottom: 0;
    margin-left: -12px;
    padding-left: 12px;

    a {
      display: inline-block;
      box-sizing: border-box;
      width: 100%;
      padding-right: 40px;
    }

    &:hover {
      background-color: ${theme.colors.state.hover};

      ${ExternalLinkIcon} {
        display: block;
      }
    }
  `
)

export const SymbolContainer = styled(Flex)<FlexProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-weight: 400;
  line-height: 1.2;
  ${truncateStyles};
`

export const SymbolPath = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.foreground.secondary.D};
    font-size: ${theme.fontSizes.B};
  `
)

export const SymbolThumbnail = styled(ImageUnstyled)`
  display: flex;
  justify-content: center;

  img {
    max-width: 28px;
    max-height: 28px;
  }
`

export const ThumbnailBox = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    background-color: ${theme.colors.background.tertiary.C};
    border-radius: ${theme.radii.base};
    padding: 4px;
    width: 32px;
    height: 32px;
    margin-right: 8px;
  `
)

export const SymbolTruncateTooltip = styled.span`
  word-break: break-all;
`
